import { render, staticRenderFns } from "./lwList.vue?vue&type=template&id=4d138d3c&"
import script from "./lwList.vue?vue&type=script&lang=js&"
export * from "./lwList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports